export default "__VITE_PUBLIC_ASSET__5388ce1c__"